import { render, staticRenderFns } from "./testingExplain.vue?vue&type=template&id=07d9f74c&scoped=true"
import script from "./testingExplain.vue?vue&type=script&lang=js"
export * from "./testingExplain.vue?vue&type=script&lang=js"
import style0 from "./testingExplain.vue?vue&type=style&index=0&id=07d9f74c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d9f74c",
  null
  
)

export default component.exports